import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7c511276"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "imageUploader__icon-holder"
};
var _hoisted_2 = {
  "class": "repeat-answer__icon-holder"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "repeat-answer__letter"
  }, "R", -1);
});
var _hoisted_4 = {
  "class": "repeat-question__icon-holder"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "repeat-question__letter"
  }, "I", -1);
});
var _hoisted_6 = {
  "class": "sideButton muteButton__container"
};
var _hoisted_7 = {
  "class": "muteButton__icon-holder"
};
var _hoisted_8 = {
  "class": "repeat-question__icon-holder"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "repeat-question__letter"
  }, null, -1);
});
var _hoisted_10 = {
  "class": "startTalking__icon-holder",
  style: {
    "pointer-events": "none"
  }
};
var _hoisted_11 = ["value"];
var _hoisted_12 = {
  "class": "startTalking__icon-holder",
  style: {
    "pointer-events": "none"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_WalkthroughPointer = _resolveComponent("WalkthroughPointer");
  return _openBlock(), _createElementBlock("div", {
    "class": "sideButton__holder",
    style: _normalizeStyle(_ctx.returnButtonHolderStyle())
  }, [!_ctx.$store.state.aivitarX && !_ctx.$store.state.showCalls && !_ctx.$store.state.showPhone && !_ctx.$store.state.showToDoList && !_ctx.$store.state.showNotes ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "sideButton imageUploader__container",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.$store.dispatch('checkFeatureEnabled', 'imageUploader');
    })
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'image-polaroid-user'],
    "class": _normalizeClass({
      imageUploader__icon: true,
      'imageUploader__icon--active': _ctx.$store.state.showImageUploader
    })
  }, null, 8, ["class"])])])) : _createCommentVNode("", true), _createElementVNode("div", {
    "class": "sideButton repeat-answer__container",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.repeatAnswer();
    })
  }, [_createElementVNode("div", _hoisted_2, [_ctx.$store.state.TutorialPointerReplay ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0,
    style: {
      "left": "13px",
      "bottom": "12px"
    }
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: "fa-undo",
    style: {
      "transform": "scale(-1, 1)"
    },
    "class": _normalizeClass({
      'repeat-answer__icon': true,
      'repeat-answer__icon--active': _ctx.$store.state.viewChatHistory
    })
  }, null, 8, ["class"]), _hoisted_3])]), _createElementVNode("div", {
    "class": "sideButton repeat-question__container",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.repeatQuestion();
    })
  }, [_createElementVNode("div", _hoisted_4, [_ctx.$store.state.TutorialPointerInsert ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0,
    style: {
      "left": "13px",
      "bottom": "12px"
    }
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: "fa-refresh",
    "class": _normalizeClass({
      'repeat-question__icon': true,
      'repeat-question__icon--active': _ctx.$store.state.viewChatHistory
    })
  }, null, 8, ["class"]), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_ctx.$store.state.useAudio ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "fa-volume-high",
    "class": _normalizeClass({
      muteButton__icon: true,
      'muteButton__icon--active': _ctx.$store.state.viewChatHistory
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.$store.commit('updateUseAudio', false);
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.$store.state.TutorialPointerSound ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 1,
    style: {
      "left": "13px",
      "bottom": "12px"
    }
  })) : _createCommentVNode("", true), !_ctx.$store.state.useAudio ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 2,
    icon: "fa-volume-xmark",
    "class": _normalizeClass({
      muteButton__icon: true,
      'muteButton__icon--active': _ctx.$store.state.viewChatHistory
    }),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.$store.commit('updateUseAudio', true);
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true)])]), !_ctx.$store.state.aivitarX ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    "class": "sideButton camera__container",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.cameraClick();
    })
  }, [_createElementVNode("div", _hoisted_8, [_ctx.$store.state.continuousListenMode === false ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: ['fad', 'camera-retro'],
    "class": _normalizeClass({
      camera__icon: true,
      'camera__icon--active': _ctx.$store.state.showCamera
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _ctx.$store.state.continuousListenMode === true ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: ['fad', 'video'],
    "class": _normalizeClass({
      camera__icon: true,
      'camera__icon--active': _ctx.$store.state.showCamera
    })
  }, null, 8, ["class"])) : _createCommentVNode("", true), _hoisted_9])])) : _createCommentVNode("", true), !_ctx.$store.state.textOnlyMode && _ctx.$store.state.onDeviceAudioRecording ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    "class": _normalizeClass({
      sideButton: true,
      startTalking__container: true,
      'startTalking__container--live': this.$store.state.userTalking || _ctx.$store.state.isListening && _ctx.$store.state.conversationOngoing,
      'startTalking__container--aiTalking': this.$store.state.aiTalking || this.$store.state.conversationOngoing && !this.$store.state.isListening
    }),
    onClick: _cache[6] || (_cache[6] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.manyButtonsAction();
    })
  }, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_font_awesome_icon, {
    icon: _ctx.returnTalkingIcon(),
    "class": _normalizeClass({
      startTalking__icon: true,
      'changeAvatar__icon--active': _ctx.$store.state.viewChatHistory
    })
  }, null, 8, ["icon", "class"]), _ctx.$store.state.TutorialPointerSpeak ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0,
    style: {
      "left": "13px",
      "bottom": "112px"
    }
  })) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), !_ctx.$store.state.textOnlyMode && !_ctx.$store.state.onDeviceAudioRecording ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    "class": _normalizeClass({
      sideButton: true,
      startTalking__container: true,
      'startTalking__container--live': this.$store.state.userTalking || _ctx.$store.state.isListening && _ctx.$store.state.conversationOngoing,
      'startTalking__container--aiTalking': this.$store.state.aiTalking || this.$store.state.conversationOngoing && !this.$store.state.isListening
    }),
    onClick: _cache[7] || (_cache[7] = function ($event) {
      _ctx.$store.dispatch('buzzPhone');
      _ctx.startTalkingNow();
    })
  }, [_createElementVNode("progress", {
    "class": "mic_level",
    max: "10",
    value: _ctx.volume
  }, _toDisplayString(_ctx.volume) + "%", 9, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createVNode(_component_font_awesome_icon, {
    icon: _ctx.returnTalkingIcon(),
    "class": _normalizeClass({
      startTalking__icon: true,
      'changeAvatar__icon--active': _ctx.$store.state.viewChatHistory
    })
  }, null, 8, ["icon", "class"])])], 2)) : _createCommentVNode("", true)], 4);
}